import React, { useEffect, useRef } from "react";
import { FileText, X } from "lucide-react";

/** Textarea yang otomatis memanjang ke bawah mengikuti panjang isi (tanpa scrollbar). */
export function AutoGrowTextarea({ value, onChange, placeholder, maxLength = 2000, dataTestid, minRows = 2 }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "0px";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);
  return (
    <textarea
      ref={ref}
      rows={minRows}
      className="pp-input resize-none overflow-hidden leading-relaxed"
      value={value}
      placeholder={placeholder}
      maxLength={maxLength}
      onChange={(e) => onChange(e.target.value)}
      data-testid={dataTestid}
    />
  );
}

/** Sel "Lihat Deskripsi" — tampil tombol yang membuka popover/memo berisi deskripsi penuh. */
export function DeskripsiButton({ text, dataTestid }) {
  const [open, setOpen] = React.useState(false);
  const hasText = !!(text && String(text).trim());
  if (!hasText) return <span className="text-xs text-slate-300 italic">—</span>;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-lg border border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 text-xs font-semibold transition-colors"
        data-testid={dataTestid}
      >
        <FileText className="w-3.5 h-3.5" /> Lihat
      </button>
      {open && (
        <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-2xl max-w-lg w-full p-5 shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="deskripsi-modal">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-bold text-slate-900 flex items-center gap-2"><FileText className="w-4 h-4 text-indigo-600" /> Deskripsi</h4>
              <button onClick={() => setOpen(false)} data-testid="deskripsi-close"><X className="w-5 h-5 text-slate-400 hover:text-slate-600" /></button>
            </div>
            <div className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed bg-slate-50 border border-slate-200 rounded-lg p-3 max-h-[60vh] overflow-y-auto">{text}</div>
          </div>
        </div>
      )}
    </>
  );
}
